/**
 * Invite and Waitlists (`/invite`, `/waitlists`, web-account-pages D10): the app's Coming soon
 * pages. Below 768px the app's page with its header and bar; on a computer its card alone.
 * Display only.
 */
import { ComingSoonCard } from '@/pages/client/ComingSoonPage';

import { useSiteStudio } from '../api/site';
import { COMING_SOON, PhoneComingSoon } from '../phone/PhoneComingSoon';
import shared from '../styles/shared.module.css';
import { useAppScreens } from '../ui/useIsPhone';
import { usePageTitle } from '../ui/usePageTitle';

export function ComingSoonPage({ screen }: { readonly screen: keyof typeof COMING_SOON }) {
  const { title, testId, copy } = COMING_SOON[screen];
  usePageTitle(title);
  const phone = useAppScreens();
  const studio = useSiteStudio().data;
  if (phone) return <PhoneComingSoon screen={screen} />;
  return studio ? (
    <div className={shared.wrap}>
      <ComingSoonCard copy={copy(studio.name)} testId={testId} />
    </div>
  ) : null;
}
